import {
  XAcquireTechCard,
  XBadgeCounter,
  XButton,
  XCard,
  XCardBack,
  XResourceWithAmount,
  XTypography,
} from "~/jsx/components/design";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useActions, useGraphicScale, useViewingPlayerOpt } from "~/jsx/hook";
import { Sizes } from "~/jsx/theme";
import { useModal } from "~/utils";
import { XHand } from "./XHand";
import { getLobbyGameParams } from "~/business";
import { useLobbyGame } from "~/app";

export const XPlayerInfos = () => {
  const lobbyGame = useLobbyGame();
  const { useIxExtension = false } = getLobbyGameParams(lobbyGame) ?? {};
  const { scaleHeight } = useGraphicScale();
  const { onReveal } = useActions();
  const { show: showDiscards } = useModal(ModalNames.discardCards);
  const { show: showIntrigueCards } = useModal(ModalNames.intrigue);
  const { show: showTechModal } = useModal(ModalNames.tech);
  const { show: showDeck } = useModal(ModalNames.lookDeck);
  const viewingPlayer = useViewingPlayerOpt();
  if (!viewingPlayer) return null;
  const { intrigueCards, discard, playZone, revealZone, deck } = viewingPlayer;

  return (
    <div
      style={{
        padding: 10,
        backgroundColor: "rgba(217, 217, 217, 0.8)",
        boxShadow: "0px -6px 4px rgba(0, 0, 0, 0.12)",
        borderRadius: "12px 12px 0px 0px",
        height: 250 * scaleHeight,
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          transform: `scale(${scaleHeight})`,
          transformOrigin: "top left",
        }}
      >
        <div style={{ display: "flex", gap: 10 }}>
          <div style={{ zIndex: 2 }}>
            {discard.length ? (
              <>
                <div style={{ width: Sizes.cardWidths.small }}>
                  {discard.pile.map((card) => {
                    return (
                      <div
                        key={card.id}
                        style={{ position: "absolute", top: 0, left: 0 }}
                      >
                        <XCard
                          card={card}
                          width={Sizes.cardWidths.small}
                          onClick={() => showDiscards()}
                        />
                      </div>
                    );
                  })}
                </div>
                <XBadgeCounter value={discard.length} />
              </>
            ) : (
              <div
                style={{
                  width: Sizes.cardWidths.small,
                  height: Sizes.cardWidths.small * Sizes.card.ratio,
                  border: "dashed 1px black",
                  borderRadius: 12,
                }}
              ></div>
            )}
          </div>
          <div>
            <XCardBack
              width={Sizes.cardWidths.small}
              onClick={viewingPlayer.deck.length ? () => showDeck() : undefined}
            />
            <XBadgeCounter value={deck.length} />
          </div>
        </div>
        <div style={{ display: "flex", gap: 20 }}>
          <div style={{ display: "flex", gap: 5 }}>
            {playZone.pile.map((card) => (
              <XCard key={card.id} card={card} width={Sizes.cardWidths.small} />
            ))}
          </div>
          <div style={{ display: "flex", gap: 5 }}>
            {revealZone.pile.map((card) => (
              <XCard key={card.id} card={card} width={Sizes.cardWidths.small} />
            ))}
          </div>
        </div>
      </div>
      <XHand
        style={{ transform: `scale(${scaleHeight})`, transformOrigin: "top" }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          transform: `scale(${scaleHeight})`,
          height: "100%",
        }}
      >
        <XButton
          style={{ width: "fit-content" }}
          onClick={
            viewingPlayer.intrigueCards.length
              ? () => showIntrigueCards()
              : undefined
          }
        >
          <XResourceWithAmount
            type="intrigueCard"
            amount={intrigueCards.length}
            width={24}
            variant="separated"
          />
        </XButton>
        {useIxExtension && (
          <XButton
            style={{ width: "fit-content" }}
            onClick={
              viewingPlayer.techTiles.length ? () => showTechModal() : undefined
            }
          >
            <XAcquireTechCard width={32} />
          </XButton>
        )}
        <XButton onClick={onReveal}>
          <XTypography>Reveal</XTypography>
        </XButton>
      </div>
    </div>
  );
};
